<template>
  <div style="margin-bottom:10px">
    <div style="display:flex">
      <b-button
        v-if="!isDisabled"
        style="margin-right:10px"
        variant="outline-danger"
        size="sm"
        @click="(changed) ? update(data.original_name, data.generate) : lock()"
      >
        <feather-icon
          v-if="!changed"
          icon="UnlockIcon"
          size="12"
        />
        <span v-if="changed">
          SAVE
        </span>
      </b-button>
      <b-button
        v-if="isDisabled"
        style="margin-right:10px"
        variant="outline-success"
        size="sm"
        @click="unlock"
      >
        <feather-icon
          icon="LockIcon"
          size="12"
        />
      </b-button>
      <b-input-group
        :class="inputStyle"
        :prepend="data.name"
      >
        <b-form-input
          v-if="textInput"
          :id="data.name"
          v-model="inputValue"
          :state="state"
          :disabled="isDisabled"
          :readonly="readonly"
          @change="changed = true"
          @keypress="changed = true"
        />
        <b-form-spinbutton-input
          v-if="numberInputAdd"
          :id="data.name"
          v-model="inputValue"
          :disabled="isDisabled"
          :readonly="readonly"
          :state="state"
          :min="1"
          :max="1000000"
          :width="140"
          @change="changed = true"
          @keypress="changed = true"
        />
        <b-form-spinbutton
          v-if="numberInput"
          :id="data.name"
          v-model="inputValue"
          :disabled="isDisabled"
          :readonly="readonly"
          :state="state"
          min="1"
          max="10000"
          @change="changed = true"
          @keypress="changed = true"
        />
        <b-form-select
          v-if="modelInput"
          :id="data.name"
          v-model="inputValue"
          :options="selectModelOptions"
          :disabled="isDisabled"
          :readonly="readonly"
          :state="state"
          @change="changed = true"
          @keypress="changed = true"
        />
      </b-input-group>
    </div>
    <b-form-invalid-feedback>
      This is variable is required.
    </b-form-invalid-feedback>
    <b-button
      v-if="data.original_name === 'exp_design_path'"
      :disabled="btDisabled"
      variant="primary"
      size="sm"
      style="margin-top:7px;"
      @click="loadExperimental(category)"
    >
      LOAD DATA FROM EXPERIMENTAL DESIGN
    </b-button>
    <b-spinner
      v-if="data.original_name === 'exp_design_path' && isLoading"
      small
      class="ml-1"
      label="Small Spinner"
    />
    <div
      v-if="data.original_name === 'exp_design_path' && btDisabled"
      Style="margin-top:2px; color:red; font-size:10px"
    > Experimental design is incomplete</div>
  </div>
</template>
<script>
/* eslint-disable no-await-in-loop */
import {
  BFormInput, BFormInvalidFeedback, BInputGroup, BFormSelect, BButton, BFormSpinbutton, BSpinner,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import BFormSpinbuttonInput from '@core/components/b-form-spinbutton-input/BFormSpinbuttonInput.vue'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BFormInput,
    BFormInvalidFeedback,
    BInputGroup,
    BFormSpinbuttonInput,
    BFormSelect,
    BButton,
    BFormSpinbutton,
    BSpinner,
  },
  props: {
    data: {
      required: true,
      type: [String, Object],
    },
    disabled: {
      required: true,
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
      type: [String, Object, Number],
    },
    modelOptions: {
      required: true,
      type: [String, Object, Array],
    },
    server: {
      required: true,
      type: String,
    },
    user: {
      required: true,
      type: Number,
    },
    category: {
      required: false,
      default: 'processing',
      type: String,
    },
    btDisabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    isDependent: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      state: null,
      inputStyle: '',
      readonly: false,
      isExpLoad: false,
      isLoading: false,
      inputDisabled: true,
      changed: false,
    }
  },
  computed: {
    isDisabled() {
      if (this.disabled) {
        return this.disabled
      }
      return this.inputDisabled
    },
    textInput() {
      if (this.data.type === 'path') {
        return true
      }
      return false
    },
    numberInput() {
      if (this.data.type === 'int') {
        return true
      }
      return false
    },
    numberInputAdd() {
      if (this.data.type === 'intmanual') {
        return true
      }
      return false
    },
    modelInput() {
      if (this.data.type === 'model') {
        return true
      }
      return false
    },
    selectModelOptions() {
      const options = this.modelOptions
      options.unshift({ value: '', text: 'Please select an option' })
      return options
    },
  },
  watch: {
    inputValue() {
      this.setValid()
      this.changed = true
      // this.update(this.data.original_name, this.data.generate)
    },
    value() {
      this.changed = true
      this.inputValue = this.value
      if (this.changed === false && this.inputDisabled) {
        this.update(this.data.original_name, this.data.generate)
      }
      // this.update(this.data.name, this.data.generate)
    },
  },
  mounted() {
    this.setValid()
  },
  methods: {
    async update(input, generate) {
      this.lock()
      this.changed = false
      if (!this.isExpLoad) {
        const data = JSON.stringify({ project: this.$route.params.id, value: this.inputValue, category: this.category })
        console.log(data, `${url}:${port}/project_variable/${input}`)
        await axios.put(`${url}:${port}/project_variable/${input}`, data, { headers }).then(async result => {
          if (result.status === 200) {
            this.setValid()
          }
          if (generate.length > 0) {
            const codes = []
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < generate.length; index++) {
              const element = generate[index]
              if (element.generated !== null) {
                if (!codes.includes(element.generated)) {
                  codes.push(element.generated)
                  this.genVarGen(element, generate)
                }
              } else {
                this.genVar(element, element.autotext)
              }
            }
          }
        }).catch(() => {
          this.state = false
        })
      }
      this.isExpLoad = false
      return this.isExpLoad
    },
    setValid() {
      if (this.inputValue !== '' && this.inputValue !== 0) {
        this.state = true
        this.inputStyle = 'validInput'
      } else {
        this.state = null
        this.inputStyle = ''
      }
    },
    genVar(input, val) {
      let value = this.inputValue + val
      if (input.type === 'path') {
        value = (this.inputValue.charAt(this.inputValue.length - 1) === '/') ? this.inputValue + val : `${this.inputValue}/${val}`
      }
      this.$emit('genVariable', { input, value })
    },
    genVarGen(input, inputs) {
      this.readonly = true
      const json = { task_type: input.generated }
      json[input.base_input] = this.inputValue
      const data = JSON.stringify({
        project: this.$route.params.id, user: this.user, json, server: this.server,
      })
      axios.post(`${url}:${port}/variable-options/`, data, { headers }).then(result => {
        console.log(result.data)
        const { options } = result.data
        const keys = Object.keys(options)
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < keys.length; index++) {
          const key = keys[index]
          const value = options[key]
          const inputdata = inputs.find(el => el.name === key)
          console.log(inputdata, value)
          this.$emit('genVariable', { input: inputdata, value })
        }
        this.readonly = false
      })
    },
    loadExperimental(category) {
      console.log(`init loadDate:${Date.now()}`)
      this.readonly = true
      this.isLoading = true
      const { id } = this.$route.params
      // this.isExpLoad = true
      console.log("MAITE", id, category)

      axios.get(`${url}:${port}/experimental-variables/${id}/${category}`, { headers }).then(async result => {
        console.log(result)
        if (result) {
          this.inputValue = result.data.path
          await this.update(this.data.original_name, this.data.generate)
          /* this.emit('genVariable', { input: 'experimental_design_scenes', value: result.data.scenes })
          this.emit('genVariable', { input: 'experimental_design_rounds', value: result.data.rounds })
          this.emit('genVariable', { input: 'experimental_design_scenes_selection', value: result.data.scenes_selection }) */
          this.$swal({
            icon: 'success',
            title: 'Done!',
            text: 'Data was loaded from Experimental Design',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
        this.readonly = false
        this.isLoading = false
        console.log(`end loadDate:${Date.now()}`)
      })
    },
    emit(action, value) {
      console.log('emit', action, value)
      this.$emit(action, value)
      console.log('done emit', action, value)
    },
    unlock() {
      let text = ''
      if (this.isDependent) {
        text = 'It is strongly recommended not to manually modify the dependent variables'
      } else if (this.data.name === 'project_folder') {
        text = 'Modifying this path after performing computations could lead to an incompatible folder structure'
      } else {
        text = 'You are going to change the variable'
      }
      this.$swal({
        title: 'Warning!',
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Accept',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.inputDisabled = false
        }
      })
    },
    lock() {
      this.inputDisabled = true
    },
  },
}
</script>
<style scoped>
.validInput .input-group-text{
    background-color: #29c770;
    color: #fff;
}
.b-form-spinbutton{
  max-width: 100px;
}
.is-valid.b-form-spinbutton{
      max-width: 135px!important;
}
.spinBtRow{
  flex-direction: column;
}
.spinBtRow div{
    max-width: 100%!important;
}
.spinBtRow div.input-group{
  max-width: 110px!important;
}
</style>
